import React from 'react';
import { Link } from 'react-router-dom';
import personImg from '../assets/images/personImg3.png';

const CasBMain = () => {

  const mainPageData = [
    {
      title: "Google Workspace",
      color: "#eb5424",
      to: '/demo/casb/google'
    },
    {
      title: "Microsoft Office 365",
      color: "#5177FF",
      to: '/demo/casb/office365'
    },
    {
      title: "Shopify",
      color: "#B153FA",
      to: '/demo/casb/shopify'
    }
  ]

  return (
    <>
      <div className='w-100 py-3 px-5' style={{ height: '91vh' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.history.back()}>
            <span class="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back to main page</p>
          </div>
        </div>
        <div className='row align-items-center justify-content-center'>
          <div className='col-10'>
            <div className='row justify-content-center'>
              <div className='col-12  mb-5 d-flex justify-content-center align-items-center'>

                <h2 className='lh-base' style={{ color: "#555555" }}>CASB Cloud Applications</h2>

              </div>
              {mainPageData.map((item) => (
                <div className='col-12 col-sm-6 col-md-4 col-xl-3 p-2 '>
                  <Link className='text-decoration-none' to={item.to}>
                    <div className='border rounded px-5 py-4 mainPageItems h-100'>
                      <div className='d-flex w-100 justify-content-between align-items-center'>
                        <div style={{ width: "40px", height: "5px", background: `${item.color}` }} className="rounded"></div>
                        <span class="material-symbols-rounded text-dark">
                          east
                        </span>
                      </div>
                      <h5 className=' mt-4 my-3 text-black'>{item.title}</h5>
                      {item.text}
                    </div>
                  </Link>
                </div>
              ))}
            </div>

          </div>
        </div>

      </div>
    </>
  )
}

export default CasBMain